module.exports = __webpack_public_path__ + "static/media/warehouse.951cf9ee.svg";